import { BaseIndexFieldModel, SmsFieldType } from '../../data';

export interface SmsTypeRequestModel {
  name: string;
  code: string;

  smsFrom: string;
  smsContent: string;
  smsFieldType: SmsFieldType;
  notificationEmail?: string;

  contactGroupId?: number;

  indexFields: BaseIndexFieldModel[];
}
